import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import classNames from 'classnames/bind';
import { Card, ChevronRightIcon, FileDownloader, Link, Text } from '@beef/ui-kit';
import { Picture } from "../../Picture";
import { Video } from "../../Video";
import style from "./styles.module.pcss";
import { FeaturesList } from "./FeaturesList/FeaturesList";
import { Data } from "./Data";
import { EKey } from "./types";
var cn = classNames.bind(style);
export var getContent = function getContent(content) {
  var key = Object.keys(content)[0];
  switch (key) {
    case EKey.title:
      {
        return /*#__PURE__*/React.createElement(Text, {
          size: "size4-m",
          tagType: "p",
          "data-t-id": "FAQ-FaqMain"
        }, content.title);
      }
    case EKey.text:
      {
        return /*#__PURE__*/React.createElement(Text, {
          extraAttributes: {
            itemProp: 'text'
          },
          size: "size5-r-s"
        }, content.text);
      }
    case EKey.img:
      {
        var _content$img;
        if ((_content$img = content.img) !== null && _content$img !== void 0 && _content$img.src) {
          return /*#__PURE__*/React.createElement(Card, {
            bordered: false,
            className: cn('card', 'picture-card')
          }, /*#__PURE__*/React.createElement(Picture, _extends({
            className: cn('image')
          }, content.img, {
            "data-t-id": "FAQ-FaqMain"
          })));
        }
        break;
      }
    case EKey.link:
      {
        var _content$link;
        if ((_content$link = content.link) !== null && _content$link !== void 0 && _content$link.url) {
          return /*#__PURE__*/React.createElement("div", {
            className: cn('link')
          }, /*#__PURE__*/React.createElement(Link, {
            href: content.link.url,
            isNoUnderline: true,
            rightIcon: /*#__PURE__*/React.createElement(ChevronRightIcon, {
              size: "xs"
            }),
            size: "size6-m"
          }, content.link.text || 'Перейти'));
        }
        break;
      }
    case EKey.featuresList:
      {
        var _content$featuresList;
        if ((_content$featuresList = content.featuresList) !== null && _content$featuresList !== void 0 && _content$featuresList.length) {
          return /*#__PURE__*/React.createElement(FeaturesList, {
            featuresList: content.featuresList
          });
        }
        break;
      }
    case EKey.video:
      {
        var _content$video, _content$video2, _content$video3;
        if ((_content$video = content.video) !== null && _content$video !== void 0 && _content$video.src || (_content$video2 = content.video) !== null && _content$video2 !== void 0 && _content$video2.youtubeId || (_content$video3 = content.video) !== null && _content$video3 !== void 0 && _content$video3.rutubeId) {
          return /*#__PURE__*/React.createElement("div", {
            className: cn('video-wrapper')
          }, /*#__PURE__*/React.createElement(Video, _extends({}, content.video, {
            height: "100%"
          })));
        }
        break;
      }
    case EKey.data:
      {
        var _content$data;
        if (content !== null && content !== void 0 && (_content$data = content.data) !== null && _content$data !== void 0 && _content$data.length) {
          return /*#__PURE__*/React.createElement(Data, {
            data: content.data
          });
        }
        break;
      }
    case EKey.file:
      {
        var _content$file;
        if (content !== null && content !== void 0 && (_content$file = content.file) !== null && _content$file !== void 0 && _content$file.href) {
          return /*#__PURE__*/React.createElement(FileDownloader, _extends({}, content.file, {
            textSize: "size7-r"
          }));
        }
        break;
      }
    default:
  }
  return null;
};